import('./bootstrap');

// TODO: not the most convenient way to handle this — must be set before importing
//       the reCAPTCHA component (which reads global options immediately)
window.recaptchaOptions = {
  enterprise: true,
};

export {};
